import { Image, ImageProps } from '@chakra-ui/react';
import { useTheme } from '../../contexts/ThemeProvider';

export function Logo(props: ImageProps) {
  const { logo } = useTheme();

  if (!logo) return null;

  return <Image src={logo} width={'200px'} {...props} />;
}
